export enum TrainingProgramRecordStatus {
    complete = 'complete',
    incomplete = 'incomplete',
    upcoming = 'upcoming',
}
